var _module = require('../components/module');

/*
slug
converts a string to a url slug
*/
_module.filter('slug', [
    function () {
        return function slug(str) {
            return str.replace(/([^a-z0-9\s])/gi, '').replace(/(\s)/gi, '-').toLowerCase().trim();
        };
    }
]);
